var option_webview_default = {
  "option": "Mjlhd",
  "user_choice": "aUV3-",
  "check": "NDHQi",
  "image": "-wBjW",
  "input": "r4dum",
  "title": "lpKGC",
  "centered": "Ev3kC",
  "with_result": "cik6x",
  "list": "_7ZnIa",
  "with_image": "gHWvk",
  "progress": "U9Cgs",
  "progress_value": "iam-d",
  "label": "XF4Ae",
  "cta": "QD1NF",
  "adornment_icon": "ahzc9",
  "remove": "XjLwJ",
  "removeButton": "_7HnDX",
  "removeButtonIcon": "XWy0J",
  "overlay": "nwPnt",
  "shown": "DiWNV",
  "dark": "fiIKS",
  "spinner": "xwM0K",
  "spin": "_3PUck",
  "grid": "R3Cv6"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
